import { Routes, Route } from 'react-router-dom';
import Home2 from './Home2';
import CadastrarPalavra from './CadastrarPalavra';
import Cristocurasim from './Cristocurasim';

const App = () => {
    return (
        <Routes>
            <Route path="/" element={<Home2 />} />
            <Route path="/palavra" element={<CadastrarPalavra />} />
            <Route path="/Cristocurasim" element={<Cristocurasim />} />
        </Routes>
    )
};

export default App;